import api from 'api'
import { CACHE_TAG_WORK_ORDER_ROUTE_ACTIVITY_LIST } from 'api/cacheTagTypes'
import { withIdTag } from 'utils/cache'

import type { RouteActivityResponseApi, RouteActivityRowApi } from 'types/api/work-order/routeActivity'

type GetWorkOrderRouteActivityArgs = { workOrderId: string }

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    // 404s harmlessly until the BE endpoint deploys, mirroring getContainerVersionsByWoId —
    // the activity feed just skips the missing data.
    getWorkOrderRouteActivity: builder.query<RouteActivityRowApi[], GetWorkOrderRouteActivityArgs>({
      query: ({ workOrderId }) => ({ url: `/api/v1/core/work-orders/${workOrderId}/route-activity` }),
      transformResponse: (response: RouteActivityResponseApi | RouteActivityRowApi[]) =>
        Array.isArray(response) ? response : response?.activity ?? [],
      providesTags: (result, error, arg) => withIdTag(CACHE_TAG_WORK_ORDER_ROUTE_ACTIVITY_LIST, arg?.workOrderId),
    }),
  }),
})

export const { useLazyGetWorkOrderRouteActivityQuery } = extendedApi
